export const generateRandomString = (
  length: number,
  specialSymbols: string[] = ["!", "@", "#", "$", "%", "&", "*"]
): string => {
  const lower = "abcdefghijklmnopqrstuvwxyz";
  const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const numbers = "0123456789";
  const specials: string = specialSymbols.join("");

  const allChars: string = lower + upper + numbers + specials;

  if (allChars.length === 0) {
    throw new Error("No characters provided to generate string");
  }

  let result = "";
  for (let i = 0; i < length; i++) {
    const randomIndex: number = Math.floor(Math.random() * allChars.length);
    result += allChars[randomIndex];
  }

  return result;
};
